import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getEgresoLicencia } from "../../../redux/actions";
import Button from "../../../components/button";
import { formatFechaHora } from "../../../utils/formatDate";

const sectionClass =
  "bg-white rounded-lg border border-[#61ABCF] divide-y divide-[#61ABCF]";

const rowClass = "grid grid-cols-2 gap-5 px-4 py-2";

const labelClass = "text-sm/6 font-medium text-gray-900";

const valueClass = "mt-1 sm:mt-0 text-sm/6 text-gray-700";

const titleClass = "text-sm/6 font-bold text-[#036395] font-inter";

function InfoRow({ label, value, valueClassName = "" }) {
  return (
    <div className={rowClass}>
      <dt className={labelClass}>{label}</dt>
      <dd className={`${valueClass} ${valueClassName}`}>
        {value || "-"}
      </dd>
    </div>
  );
}

function SectionTitle({ children }) {
  return (
    <div className="px-4 py-2">
      <dt className={titleClass}>{children}</dt>
    </div>
  );
}

function VerEgresoLicenciaComponent({
  closeModalVerEgresoLicencia,
  idLicencia,
}) {
  const dispatch = useDispatch();

  const [egreso, setEgreso] = useState({});

  useEffect(() => {
    const fetchEgreso = async () => {
      const resp = await dispatch(getEgresoLicencia(idLicencia));
      setEgreso(resp);
    };

    fetchEgreso();
  }, [dispatch, idLicencia]);

  const env = process.env.REACT_APP_ENVIRONMENT || "development";

  const remoteDir =
    env === "production"
      ? "images/corralon/production/firmas_licencias"
      : "images/corralon/stage/firmas_licencias";

  const urlFirma = egreso?.firma?.startsWith("data:image")
    ? egreso.firma
    : `https://staticcontent.sannicolasciudad.gob.ar/${remoteDir}/${egreso?.firma}`;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80"
      onClick={closeModalVerEgresoLicencia}
    >
      <div
        className="relative flex flex-col gap-4 rounded-lg border bg-[#F5FAFF] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={closeModalVerEgresoLicencia}
          className="absolute top-1 right-2 text-gray-400 hover:text-gray-600"
        >
          ✕
        </button>

        <div className={sectionClass}>
          <SectionTitle>LICENCIA EGRESADA</SectionTitle>

          <InfoRow
            label="Fecha y Hora"
            value={formatFechaHora(egreso?.fecha_hora, "-")}
          />

          <InfoRow
            label="Firma"
            value={
              egreso?.firma ? (
                <img
                  src={urlFirma}
                  alt="firma"
                  className="max-w-[10rem]"
                />
              ) : (
                "-"
              )
            }
          />
        </div>

        <div className={sectionClass}>
          <SectionTitle>USUARIO QUE EGRESÓ</SectionTitle>

          <InfoRow
            label="Apellido y nombres"
            value={egreso?.User?.nombreCompleto}
          />

          <InfoRow
            label="DNI"
            value={egreso?.User?.dni}
          />
        </div>

        <Button
          variant="primary"
          fullWidth
          onClick={closeModalVerEgresoLicencia}
          className="h-[45px]"
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
}

export default VerEgresoLicenciaComponent;